import { Component, DestroyRef, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UserHttpService } from '../../core/services/user.http.service';
import { ToastService } from '../../core/services/toast.service';

@Component({
  selector: 'app-verify',
  imports: [
    ReactiveFormsModule,
    RouterModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './verify.html',
  styleUrl: './verify.scss',
})
export class Verify {
  readonly verifyForm: FormGroup;
  readonly isSubmitting = signal<boolean>(false);
  readonly errorMessage = signal<string>('');
  readonly successMessage = signal<string>('');

  constructor(
    private fb: FormBuilder,
    private httpService: UserHttpService,
    private router: Router,
    private destroyRef: DestroyRef,
    private toast: ToastService,
  ) {
    this.verifyForm = this.fb.group({
      otp: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  onSubmit(): void {
    this.verifyForm.markAllAsTouched();
    if (this.verifyForm.invalid || this.isSubmitting()) {
      return;
    }

    const otp = String(this.verifyForm.get('otp')?.value ?? '').trim();
    this.isSubmitting.set(true);
    this.errorMessage.set('');
    this.successMessage.set('');

    this.httpService.verifyOtp(otp).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        this.httpService.patchCurrentUser({ verified: true });
        this.httpService
          .refreshAccessToken()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: () => {
              this.isSubmitting.set(false);
              const message = String(res?.message ?? 'Account verified successfully.');
              this.successMessage.set(message);
              this.toast.success(message);
              this.router.navigate(['/dashboard']);
            },
            error: () => {
              this.isSubmitting.set(false);
              const message = String(res?.message ?? 'Account verified successfully.');
              this.successMessage.set(message);
              this.toast.success(message);
              this.router.navigate(['/dashboard']);
            },
          });
      },
      error: (error) => {
        this.isSubmitting.set(false);
        const apiMessage = String(error?.error?.message ?? '').trim();
        const message = apiMessage || 'OTP verification failed.';
        this.errorMessage.set(message);
        this.toast.error(message);
      },
    });
  }
}
